import { request } from '@/utils/axios'

/* 三会一课 删除活动 */
export function deleteActivity(params) {
  return request ({
    url: '/api/Party/DelActivity',
    method: 'get',
    params
  })
}

/* 修改活动 回显数据 */
export function updateActivityData(params) {
  return request ({
    url: '/api/Party/getActivity',
    method: 'post',
    data: params
  })
}

/* 修改活动 提交 */
export function confirmUpdateActi(params) {
  return request ({
    url: '/api/Party/UpdActivity',
    method: 'post',
    data: params
  })
}
/* 党员之家：职责分工、网上三会一课、后备干部、党务公开 */
export function getActiList(params) {
  return request ({
    url: '/api/Party/Duty',
    method: 'post',
    data: params
  })
}
